import { cn } from "@/lib/utils"

export type ShareMeterTone = "accent" | "amber" | "danger" | "emerald"

const FILL_CLASS: Record<ShareMeterTone, string> = {
  accent: "bg-ui-accent",
  amber: "bg-ui-status-rendering",
  danger: "bg-ui-danger",
  emerald: "bg-emerald-500",
}

/** Полоса доли: одна сплошная заливка, тон выбирает вызывающий. */
export function ShareMeter({
  value,
  max,
  tone,
  className,
}: {
  value: number
  max: number
  tone: ShareMeterTone
  className?: string
}) {
  const percent = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0
  return (
    <span
      aria-hidden
      className={cn("inline-flex h-1.5 w-16 shrink-0 overflow-hidden rounded-full bg-ui-surface-sunken", className)}
    >
      <span className={cn("block h-full rounded-full", FILL_CLASS[tone])} style={{ width: `${percent}%` }} />
    </span>
  )
}
